import cxs from 'cxs';

export const giftCardIconCss = cxs({
	display: 'block',
	width: '80px',
	height: '80px',
	alignSelf: 'center',
	'& > path': {
		strokeWidth: '1'
	}
});
